import './bookmark.scss';
import { h } from 'preact';
import { BaseAnnotation } from '../base_annotation';

export class Bookmark extends BaseAnnotation {
    render() {
        if (this.options.mode === 'invisible') {
            return null;
        }

        const attrs = {
            'className': 'bookmark-annotation',
            'style': this.getElementStyles(),
            'data-vertical-align': this.options.verticalAlign || 'top',
            'data-horizontal-align': this.options.horizontalAlign || 'left',
            ...this.applyActions(this.actions)
        };

        return (
            <div { ...attrs }>
                <h1>{ this.props.content }</h1>
            </div>
        );
    }

    static get schemaType() {
        return 'bookmark';
    }
}